import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";
import BaseService from "./base.service";

export default class SelectStoreService extends BaseService {
  fetchStores = (params = {}) =>
    this.axios.get(API_ENDPOINTS.SELECT_STORES, { params });
  fetchDirectors = () => this.axios.post(API_ENDPOINTS.DIRECTORS);
  fetchChains = () => this.axios.post(API_ENDPOINTS.CHAINS);
  fetchAdInCharges = ({ currentDirector }) => {
    if (currentDirector === undefined || currentDirector === null) {
      currentDirector = "";
    }
    return this.axios.get(
        API_ENDPOINTS.LIST_DIRECTORS.replace("{currentDirector}", currentDirector)
    );
  };
}
